import React, {
	Component
} from "react";
import xtend from "xtend";

import FormInput from "./FormInput";

export default class Nested extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hasChanged: false,
			value: null
		};
		this.handleChange = handleChange.bind(this);
	}

	render() {
		var propertySchema = this.props.schema;
		var inputProperty = propertySchema.inputProperty;
		var actualSchema = propertySchema.properties[inputProperty];

		var defaultValue = this.props.defaultValue || {};
		var actualDefaultValue = defaultValue[inputProperty];

		var submit = this.props.onSubmit;
		var propertyName = this.props.name;
		var contrast = this.props.contrast;
		var errors = this.props.errors;

		return (
			<FormInput
				unsupportedFeatures={this.props.unsupportedFeatures}
				platform={this.props.platform}
				id={this.props.id + "_" + inputProperty}
				schema={actualSchema}
				defaultValue={actualDefaultValue}
				onChange={this.handleChange}
				onSubmit={submit}
				name={propertyName}
				contrast={contrast}
				errors={errors}
				showCustomAddButton = {this.props.showCustomAddButton}
			/>
		);
	}
}

function handleChange(value) {
	var update = {};
	var inputProperty = this.props.schema.inputProperty;
	update[inputProperty] = value;
	var newData = xtend(this.props.defaultValue || {}, update);

	var onChange = this.props.onChange;
	if (onChange)
		onChange(newData);
}
